import DataFormatter from '@/mixins/DataFormatter';

export default {
  mixins: [DataFormatter],
  methods: {
    getFiscalYearMonths(fiscalYearStartMonth) {
      let months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      if (fiscalYearStartMonth <= 1 || fiscalYearStartMonth > 12) {
        return months;
      }

      let fiscalMonths = [];
      for (let i = fiscalYearStartMonth - 1; i < 12; i++) {
        fiscalMonths.push(months[i]);
      }
      for (let i = 0; i < fiscalYearStartMonth - 1; i++) {
        fiscalMonths.push(months[i]);
      } 
      return fiscalMonths;
    },
    isPeriodIndexAmountColumn(columnName) {
      switch(columnName) {
        case 'periodIndex00Amount':
        case 'periodIndex01Amount':
        case 'periodIndex02Amount':
        case 'periodIndex03Amount':
        case 'periodIndex04Amount':
        case 'periodIndex05Amount':
        case 'periodIndex06Amount':
        case 'periodIndex07Amount':
        case 'periodIndex08Amount':
        case 'periodIndex09Amount':
        case 'periodIndex10Amount':
        case 'periodIndex11Amount':
          return true;
        default:
          return false;
      }
    },
    getPeriodIndexFromColumn(columnName) {
      switch(columnName) {
        case 'periodIndex00Amount':
          return 0;
        case 'periodIndex01Amount':
          return 1;
        case 'periodIndex02Amount':
          return 2;
        case 'periodIndex03Amount':
          return 3;
        case 'periodIndex04Amount':
          return 4;
        case 'periodIndex05Amount':
          return 5;
        case 'periodIndex06Amount':
          return 6;
        case 'periodIndex07Amount':
          return 7;
        case 'periodIndex08Amount':
          return 8;
        case 'periodIndex09Amount':
          return 9;
        case 'periodIndex10Amount':
          return 10;
        case 'periodIndex11Amount':
          return 11;
        default:
          return null;
      }
    },
    calculateTotalAsInteger(data) {
      let runningTotal = this.parseInteger(data.periodIndex00Amount) +
        this.parseInteger(data.periodIndex01Amount) +
        this.parseInteger(data.periodIndex02Amount) +
        this.parseInteger(data.periodIndex03Amount) +
        this.parseInteger(data.periodIndex04Amount) +
        this.parseInteger(data.periodIndex05Amount) +
        this.parseInteger(data.periodIndex06Amount) +
        this.parseInteger(data.periodIndex07Amount) +
        this.parseInteger(data.periodIndex08Amount) +
        this.parseInteger(data.periodIndex09Amount) +
        this.parseInteger(data.periodIndex10Amount) +
        this.parseInteger(data.periodIndex11Amount);
      return this.parseInteger(runningTotal);
    },
    calculateTotalAsCurrency(data) {
      let runningTotal = this.parseCurrency(data.periodIndex00Amount) +
        this.parseCurrency(data.periodIndex01Amount) +
        this.parseCurrency(data.periodIndex02Amount) +
        this.parseCurrency(data.periodIndex03Amount) +
        this.parseCurrency(data.periodIndex04Amount) +
        this.parseCurrency(data.periodIndex05Amount) +
        this.parseCurrency(data.periodIndex06Amount) +
        this.parseCurrency(data.periodIndex07Amount) +
        this.parseCurrency(data.periodIndex08Amount) +
        this.parseCurrency(data.periodIndex09Amount) +
        this.parseCurrency(data.periodIndex10Amount) +
        this.parseCurrency(data.periodIndex11Amount);
      return this.parseCurrency(runningTotal);      
    },
    calculateAverageAsInteger(data) {
      let total = this.calculateTotalAsInteger(data);
      return this.parseInteger(total / 12);
    },
    calculateAverageAsCurrency(data) {
      let total = this.calculateTotalAsCurrency(data);
      return this.parseCurrency(total / 12);      
    },
    getRowNodePeriodIndexAmount(nodeData, periodIndex) {
      switch (periodIndex) {
        case 0:
          return nodeData.periodIndex00Amount;
        case 1:
          return nodeData.periodIndex01Amount;
        case 2:
          return nodeData.periodIndex02Amount;
        case 3:
          return nodeData.periodIndex03Amount;
        case 4:
          return nodeData.periodIndex04Amount;
        case 5:
          return nodeData.periodIndex05Amount;
        case 6:
          return nodeData.periodIndex06Amount;
        case 7:
          return nodeData.periodIndex07Amount;
        case 8:
          return nodeData.periodIndex08Amount;
        case 9:
          return nodeData.periodIndex09Amount;
        case 10:
          return nodeData.periodIndex10Amount;
        case 11:
          return nodeData.periodIndex11Amount;
        default:
          break;
      }
    },
    setRowNodePeriodIndexAmount(nodeData, periodIndex, amount) {
      switch (periodIndex) {
        case 0:
          nodeData.periodIndex00Amount = amount;
          break;
        case 1:
          nodeData.periodIndex01Amount = amount;
          break;
        case 2:
          nodeData.periodIndex02Amount = amount;
          break;
        case 3:
          nodeData.periodIndex03Amount = amount;
          break;
        case 4:
          nodeData.periodIndex04Amount = amount;
          break;
        case 5:
          nodeData.periodIndex05Amount = amount;
          break;
        case 6:
          nodeData.periodIndex06Amount = amount;
          break;
        case 7:
          nodeData.periodIndex07Amount = amount;
          break;
        case 8:
          nodeData.periodIndex08Amount = amount;
          break;
        case 9:
          nodeData.periodIndex09Amount = amount;
          break;
        case 10:
          nodeData.periodIndex10Amount = amount;
          break;
        case 11:
          nodeData.periodIndex11Amount = amount;
          break;
        default:
          break;
      }
    },
    showGridLoadingOverlay(gridOptions) {
      if (gridOptions && gridOptions.api && gridOptions.api.showLoadingOverlay) {
        gridOptions.api.showLoadingOverlay(); 
      }
    },
    sizeGridColumns(gridOptions) {
      if (gridOptions && gridOptions.api && gridOptions.api.sizeColumnsToFit) {
        gridOptions.api.sizeColumnsToFit(); 
      }
    },
    hideGridLoadingOverlay(gridOptions) {
      if (gridOptions && gridOptions.api && gridOptions.api.hideOverlay) {
        gridOptions.api.hideOverlay(); 
      }
    }
  }
}